import React from 'react';
import { ChartData, ChartOptions } from 'chart.js';
import { BaseChart, monthLabels } from '@components/base-chart/base-chart';

const maxValueY = 2000;
const minValueY = 0;
const stepSize = 500;
const unit = 'kWh';

const chartOptions: ChartOptions<'bar'> = {
  plugins: {
    tooltip: {
      callbacks: {
        // TODO format value in bff (will be done during next task)
        label: context =>
          `${new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(
            (context.raw as EnergyYieldPerMonth).value
          )} ${unit}`
      }
    }
  },
  scales: {
    y: {
      min: minValueY,
      max: maxValueY,
      ticks: {
        stepSize
      }
    }
  }
};

export const SolarYieldChart: React.FC<{
  energyYieldsPerMonth?: EnergyYieldPerMonth[];
}> = ({ energyYieldsPerMonth }) => {
  const chartData: ChartData<'bar', EnergyYieldPerMonth[]> = {
    labels: monthLabels,
    datasets: [
      {
        label: 'Solarenergie',
        data: energyYieldsPerMonth || [],
        parsing: {
          yAxisKey: 'value',
          xAxisKey: 'monthIndex'
        }
      }
    ]
  };

  return (
    <BaseChart<EnergyYieldPerMonth[]>
      chartData={chartData}
      chartOptions={chartOptions}
      unit={unit}
    />
  );
};
